import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { format } from 'date-fns';
import type { ProjectDetails } from '@/types/project';

export const TimelineTab: React.FC<{ project: ProjectDetails }> = ({ project }) => {
  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Project Timeline</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-sm font-medium">Start Date</p>
              <p className="text-sm text-muted-foreground">
                {format(project.timeline.startDate, 'MMMM d, yyyy')}
              </p>
            </div>
            <div>
              <p className="text-sm font-medium">End Date</p>
              <p className="text-sm text-muted-foreground">
                {format(project.timeline.endDate, 'MMMM d, yyyy')}
              </p>
            </div>

          </div>
        </CardContent>
      </Card>
    </>
  );
};
